import { TFunction } from 'i18next';
import { filterUndefinedRows } from 'src/js/pages/statistic/statistic-mapper';
import { StatisticSectionViewModel } from 'src/js/pages/statistic/statistic-view-model';
import { toTitleCase } from 'src/js/util/global-util';
import { formatUptime } from '../stream/stream-helper';

import { EssenceViewModel, essenceStateToName } from './essence-models';

export const mapEssenceToStatistics = (essence: EssenceViewModel, t: TFunction): StatisticSectionViewModel[] => {
  const stats = [
    {
      title: t('essence.statistics.st2110'),
      rows: [
        {
          name: t('general.status'),
          value: toTitleCase(essenceStateToName(essence.state, t), false),
        },
        {
          name: t('essence.statistics.streamSync'),
          value: essence.stats.streamSync ? t('general.on') : t('general.off'),
        },
        {
          name: t('essence.statistics.rxPackets'),
          value: essence.stats.rxPackets,
        },
        {
          name: t('essence.statistics.rxDiscardedPackets'),
          value: essence.stats.rxDiscardedPackets,
        },
        {
          name: t('essence.statistics.rxLostPackets'),
          value: essence.stats.rxLostPackets,
        },
        {
          name: t('essence.statistics.videoFormatDetectionState'),
          value: toTitleCase(essence.stats.videoFormatDetectionState, false),
        },
        {
          name: t('essence.statistics.detectedVideoFormat'),
          value: essence.stats.detectedVideoFormat,
        },
        {
          name: t('statistics.stream.rows.lastReset'),
          value: formatUptime(essence.stats.lastReset),
        },
      ],
    },
  ];

  return filterUndefinedRows(stats);
};
